import React, {
  useEffect,
  useState
} from 'react'
import { connect } from 'react-redux'
import { Accordion } from 'semantic-ui-react'
import { format } from 'date-fns'
import { AxiosResponse } from 'axios'
// Local
import {
  API_URL,
  FORMAT
} from '../../../constant'
import { Encounter } from '../../authenticated/types'
import { api } from '../../../action/api'
import { isCancelledEncounter } from '../../patient/utils'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  encounter: Encounter | undefined
  encounterId: string
  index: number
  onClickGoToPrevious: (id: string) => void
  subjectId: string
}

function PreviousEncounters(
  props: Props
): JSX.Element | null {
  const {
    currentUser,
    encounter,
    encounterId,
    index,
    onClickGoToPrevious,
    subjectId
  } = props
  const [
    encounters,
    setEncounters
  ] = useState<Record<string, any>[] | null>(null)

  const handleTitleClick = (previous: Record<string, any>) => {
    onClickGoToPrevious(previous.item.id as string)
  }

  const fetchEncounters = () => {
    const url = API_URL.GET_PREVIOUS_ENCOUNTERS_BY_SUBJECT_ID_WITH_ROLE(
      currentUser.type,
      subjectId,
      encounterId
    )
    api.get(url).then((response: AxiosResponse<Record<string, any>[]>) => {
      setEncounters(response.data)
    })
  }

  useEffect(() => {
    fetchEncounters()
  }, [])

  const generateTableData = () => {
    if (!encounters || encounters.length === 0) return []

    const result = []

    const map = new Map()

    // eslint-disable-next-line no-restricted-syntax
    for (const item of encounters) {
      if (!map.has(item.id as string)) {
        map.set(
          item.id as string,
          true
        )
        result.push({
          item
        })
      }
    }

    return result
  }

  const className = isCancelledEncounter(encounter)
    ? 'cancelled-encounter'
    : ''

  const getAccordionTitle = (previous: Record<string, any>) => (
    <Accordion.Title
      key={ previous.item.id as string }
      index={ previous.item.id as string }
      onClick={ () => { handleTitleClick(previous) } }
      className={
        index === 0
          ? 'flex-title first-accordion'
          : 'flex-title'
      }
    >
      <div className={ className }>
        { format(previous.item.start as number, FORMAT.DATE) } - { previous.item.reasonDescription }
      </div>
    </Accordion.Title>
  )

  if (encounters) {
    return (
      <div className="condition">
        {
          generateTableData().map(previous => (
            getAccordionTitle(previous)
          ))
        }
      </div>
    )
  }
  return null
}

export default connect(mapStateToProps)(PreviousEncounters)
